// What the evidence item Photos tab treats as a photo, by file type. Every
// file in an item's Evidence Files folder is tagged evidence_photo, whatever
// it is, so the tab narrows to these; other files belong to the evidence
// Files tab. The API counts photo_count with the same list
// (EVIDENCE_PHOTO_IMAGE_EXTENSIONS in monolith-api files.types.ts); keep the two
// in sync.
export const EVIDENCE_PHOTO_EXTENSIONS = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "webp",
  "heic",
  "bmp",
  "tiff",
  // Same format as tiff, the more common spelling.
  "tif",
];

// The Photos tab banner's dismissal key (ENG-2133). Bump the version when the
// copy changes enough that users who closed it should see it again.
export const EVIDENCE_PHOTOS_BANNER_ID = "evidence-photos-tab:v1";
